// ============================================================================
// APPROVAL ENDPOINTS
// ============================================================================
// API endpoint definitions for the Approval Inbox

import { buildEndpoint } from './base.endpoints';
import type { ID } from '../types/common.types';

const BASE_PATH = '/Approval';

export const approvalEndpoints = {
  /** GET /Approval — list approvals (paginated, filterable) */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /Approval/{id} — get one */
  getById: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** POST /Approval/{id}/approve — approve */
  approve: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/approve`),

  /** POST /Approval/{id}/reject — reject (also cancels the booking + releases inventory) */
  reject: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/reject`),

  /** GET /Approval/routing — all approval-routing rows (type → approver role) */
  routing: () => buildEndpoint(`${BASE_PATH}/routing`),

  /** PUT /Approval/routing/{id} — repoint a routing row's approver role (senior only) */
  updateRouting: (id: ID) => buildEndpoint(`${BASE_PATH}/routing/${id}`),

  /** POST /Approval/routing/override — add a property-scoped routing override (senior only) */
  createRoutingOverride: () => buildEndpoint(`${BASE_PATH}/routing/override`),

  /**
   * DELETE /Approval/routing/override/{id}?rowVersion=N — retire a property
   * override so the type falls back to its global routing (senior only).
   */
  retireRoutingOverride: (id: ID, rowVersion: number) =>
    buildEndpoint(`${BASE_PATH}/routing/override/${id}?rowVersion=${rowVersion}`),

  /** GET /Approval/contributed — other modules' items awaiting the caller (the restaurant's requisitions, S3b) */
  contributed: () => buildEndpoint(`${BASE_PATH}/contributed`),

  /** POST /Approval/contributed/{source}/{itemId}/approve|reject — decided by the module that owns the item */
  decideContributed: (source: string, itemId: ID, decision: 'approve' | 'reject') =>
    buildEndpoint(`${BASE_PATH}/contributed/${encodeURIComponent(source)}/${itemId}/${decision}`),
};

export default approvalEndpoints;
